import { type FunctionComponent, useState } from "react";
import EditRadiusForm from "./EditRadiusForm.tsx";
import IsEmpty from "./IsEmpty";
import { makeRipple } from "@/react/core/ripple-utils.ts";
import { router } from "@/pos/PosRouter.ts";
import { mainScreen } from "@/data/PosSettingsSignal.ts";
import DeliveryZoneList from "@delivery-management/SetShippingFees/DeliveryZoneList.tsx";
import DeliveryFeesTable from "@delivery-management/SetShippingFees/DeliveryFeesTable.tsx";
import DeliveryFeesTableMobile from "@delivery-management/SetShippingFees/DeliveryFeesTableMobile.tsx";
import {
  addNewSetting,
  deliveryMode,
  isEmptySetting,
  setDeliveryMode
} from "@/react/SetShippingFeesView/SetShippingFeesLogic.tsx";
import ViewMap from "@delivery-management/DeliveyMangement/ViewMap.tsx";
import { LL0 } from "@/react/core/I18nService.tsx";

export type SetShippingFeesRadiusPluType = {
  className?: string;
};

const SetShippingFeesPlugin: FunctionComponent<
  SetShippingFeesRadiusPluType
> = ({ className = "" }) => {

  const [open, setOpen] = useState(false)
  const [isNew, setIsNew] = useState(false)

  return (
    <div
      className={`w-full bg-[#374251] max-w-full h-full overflow-hidden flex flex-row items-start justify-start text-center text-[14px] text-[#000] font-[Mulish] ${className}`}
    >
      {deliveryMode() === "radius" && <DeliveryFeesTable className='' />}
      {deliveryMode() === "radius" && <DeliveryFeesTableMobile className='' />}
      {deliveryMode() === "zone" &&
        <div className="self-stretch flex-1 overflow-y-auto flex flex-col items-start justify-start text-center text-[14px] text-[#fff] font-[Mulish]">
          {/*<GoogleMapsProvider>*/}
          <ViewMap type={'editZone'} />
          {/*</GoogleMapsProvider>*/}
        </div>}
      <div
        className="self-stretch flex-1 shadow-[0px_0px_4px_rgba(0,_0,_0,_0.4)_inset] bg-[#fff] overflow-y-auto flex flex-col items-center justify-start max-w-[324px] md:w-[280px] sm:w-[250px] sm:max-w-[290px] mq768:w-[230px] mq768:max-w-[260px] mq600:w-[230px] mq600:max-w-[240px] h.414:w-[230px]">
        <div
          className="self-stretch rounded-[1px] bg-[#545e6a] h-[38px] shrink-0 flex flex-row items-center justify-end py-[2px] px-[8px] box-border gap-[4px] z-[2] sm:pl-[4px] sm:pr-[4px] sm:box-border mq768:pl-[4px] mq768:pr-[4px] mq768:box-border mq600:pl-[4px] mq600:pr-[4px] mq600:box-border">
          <div className="flex-1 flex flex-col items-start justify-start relative gap-[4px]">
            <div
              className="self-stretch rounded-[100px] bg-[#fff] h-[34px] overflow-hidden shrink-0 flex flex-row items-center justify-between py-[0px] px-[10px] box-border z-[0] mq768:h-[30px]"
              ref={makeRipple}
              onClick={() => setOpen(v => !v)}
            >
              <div className="relative font-semibold sm:text-[13px] mq600:text-[12px] h.414:text-[12px]">
                {deliveryMode() === "radius" ? LL0().deliveryManagement.deliveryRadius() : LL0().deliveryManagement.deliveryZone()}
              </div>
              <div className="flex flex-row items-center justify-start gap-[4px]">
                {!open ?
                  <img
                    className="w-[24px] relative h-[24px] object-cover"
                    alt=""
                    src="/iconarrow-down@2x.png"
                  />
                  :
                  <img
                    className="w-[24px] relative h-[24px] object-cover"
                    alt=""
                    src="/iconarrow-up@2x.png"
                  />}
              </div>
            </div>
            {open &&
              <div
                className="w-full !m-[0] absolute top-[38px] right-[0px] left-[0px] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] rounded-[8px] bg-[#fff] overflow-y-auto flex-col items-start justify-start gap-[2px] z-[1]">
                <div
                  className="self-stretch overflow-hidden shrink-0 flex flex-row items-center justify-start p-[10px] relative"
                  ref={makeRipple}
                  onClick={() => {
                    setDeliveryMode("radius")
                    setOpen(false)
                  }}
                >
                  <div
                    className="w-full absolute !m-[0] h-full top-[0%] right-[0%] bottom-[0%] left-[0%] bg-[#e2f0ff] hidden z-[0]" />
                  <div className="relative font-medium z-[1] sm:text-[13px] mq600:text-[12px] h.414:text-[12px]">
                    {LL0().deliveryManagement.deliveryRadius()}
                  </div>
                </div>
                <div
                  className="self-stretch overflow-hidden shrink-0 flex flex-row items-center justify-start p-[10px] relative"
                  ref={makeRipple}
                  onClick={() => {
                    setDeliveryMode("zone")
                    setOpen(false)
                  }}
                >
                  <div
                    className="w-full absolute !m-[0] h-full top-[0%] right-[0%] bottom-[0%] left-[0%] bg-[#e2f0ff] hidden z-[0]" />
                  <div className="relative font-medium z-[1] sm:text-[13px] mq600:text-[12px] h.414:text-[12px]">
                    {LL0().deliveryManagement.deliveryZone()}
                  </div>
                </div>
              </div>}
          </div>
          <div
            onClick={async () => {
              await addNewSetting(deliveryMode())
            }}
            className="self-stretch shadow-[0px_0px_6px_rgba(0,_0,_0,_0.22)] rounded-[100px] [background:linear-gradient(180deg,_#c0ed83,_#89d81f)] overflow-hidden flex flex-row items-center justify-center py-[0px] px-[24px] text-[12px] text-[#1e1e23] sm:flex-1 sm:self-stretch sm:h-auto sm:pl-[4px] sm:pr-[8px] sm:box-border sm:max-w-[90px] mq768:flex-1 mq768:self-stretch mq768:h-auto mq768:max-w-[80px] mq600:max-w-[70px]">
            <b className="relative leading-[17px] mq768:text-[10px] mq768:block mq600:text-[10px] h.414:text-[10px]">
              {LL0().deliveryManagement.addNew()}
            </b>
          </div>
          <div
            className="self-stretch shadow-[0px_0px_6px_rgba(0,_0,_0,_0.22)] rounded-[100px] bg-[#1271ff] overflow-hidden flex flex-row items-center justify-center py-[2px] px-[10px] gap-[3px] text-[#fff] sm:pl-[8px] sm:pr-[8px] sm:box-border mq768:pl-[8px] mq768:pr-[8px] mq768:box-border mq600:pl-[8px] mq600:pr-[8px] mq600:box-border h.414:pl-[8px] h.414:pr-[8px] h.414:box-border">
            <img
              onClick={() => router.screen = mainScreen()}
              className="w-[30px] relative h-[30px] object-cover mq768:w-[26px] mq768:h-[26px]"
              alt=""
              src="/iconback-icon@2x.png"
            />
            <b className="relative leading-[17px] hidden">{LL0().deliveryManagement.button()}</b>
          </div>
        </div>
        {isNew && <div
          className="self-stretch rounded-[1px] bg-[#545e6a] h-[38px] shrink-0 flex flex-row items-center justify-end py-[2px] px-[12px] box-border gap-[10px] z-[1] text-[#fff] sm:pl-[4px] sm:pr-[4px] sm:box-border mq768:pl-[4px] mq768:pr-[4px] mq768:box-border mq600:pl-[4px] mq600:pr-[4px] mq600:box-border">
          <div
            className="flex-1 shadow-[0px_0px_6px_rgba(0,_0,_0,_0.22)] rounded-[100px] [background:linear-gradient(180deg,_#ffda68,_#e3ac00)] h-[34px] overflow-hidden flex flex-row items-center justify-center py-[2px] px-[10px] box-border gap-[3px]">
            <img
              className="w-[30px] relative h-[30px] object-cover hidden"
              alt=""
              src="/ordervoucher-icon@2x.png"
            />
            <b className="relative leading-[17px] sm:text-[12px] mq768:text-[12px] mq600:text-[12px]">
              {LL0().ui.cancel()}
            </b>
          </div>
          <div
            className="flex-1 shadow-[0px_0px_6px_rgba(0,_0,_0,_0.22)] rounded-[100px] [background:linear-gradient(180deg,_#9de345,_#3ea920)] h-[34px] overflow-hidden flex flex-row items-center justify-center py-[2px] px-[10px] box-border gap-[3px]">
            <img
              className="w-[30px] relative h-[30px] object-cover hidden"
              alt=""
              src="/ordervoucher-icon1@2x.png"
            />
            <b className="relative leading-[17px] sm:text-[12px] mq768:text-[12px] mq600:text-[12px]">
              {LL0().article.save()}
            </b>
          </div>
        </div>}
        <div
          className="self-stretch flex-1 overflow-y-auto shrink-0 flex flex-col items-center justify-start gap-[12px] z-[0]">
          {isEmptySetting() ? <IsEmpty /> :
            <>
              {deliveryMode() === "radius" && <EditRadiusForm />}
              {deliveryMode() === "zone" && <DeliveryZoneList />}
            </>
          }
        </div>
      </div>
    </div>
  );
};

export default SetShippingFeesPlugin;